





































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import RequirementList from './components/requirementList.vue';
import RequirementDetail from './components/requirementDetail.vue';
import {
  compareObj,
  searchParamsConvertArray,
  ISearchTag,
} from '@/utils/other';
import SearchModal from '@/components/searchModal/searchModal.vue';
import { requirementListInstance } from '@/model/RequirementListClass';
import { TagsViewModule } from '@/store/modules/tagsView';

type IGetRequirement = IRequirement.IRequest.IGetRequirement;


type IRequirementStatusTxt = IRequirement.IRequirementStatus;
type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

interface ISearchParams {
  title?: string;
  status?: IRequirementStatusTxt;
}

@Component({
  name: 'Requirement',
  components: {
    RequirementList,
    RequirementDetail,
    SearchModal,
  },
})
export default class Requirement extends Vue {
  @Ref() private readonly searchModalRef!: SearchModal;
  private searchByKeyword: string = '';
  private searchByStatus: IRequirementStatusTxt | 'All' = 'All';
  private searchStatusOption: Array<IRequirementStatusTxt | 'All'> = ['All', 'Rejected', 'Cancel', 'Closed', 'Request', 'Approved'];
  private requirementForSearch: IGetRequirement = {};
  private searchTags: ISearchTag[] = [];
  private isInitData = false;
  private requirementListInstance = requirementListInstance;
  private listSpinning = false;
  private detailSpinning = false;
  private addLoading = false;
  get listData() {
    return this.requirementListInstance.list.data;
  }
  get currentRequirement() {
    return this.requirementListInstance.list.current;
  }
  get activeId() {
    return this.currentRequirement?.id || '';
  }
  get isMore() {
    return this.requirementListInstance.isMore;
  }
  private created() {
    this.initData();
  }
  private activated() {
    this.initData();
  }
  private initData() {
    if (Object.keys(this.$route.params).length && !compareObj(this.$route.params, this.requirementForSearch)) {
      this.requirementForSearch = { ...this.$route.params };
      this.searchTags = searchParamsConvertArray(this.requirementForSearch);
      this.handleRefresh();
      this.isInitData = true;
      TagsViewModule.ChangeView({...this.$route, params: {}});
      return;
    }
    if (!this.isInitData) {
      this.initRequirements(this.requirementForSearch);
      this.isInitData = true;
    }
  }
  private destroyed() {
    requirementListInstance.list.clearData();
  }
  private initRequirements(params?: IRequirement.IRequest.IGetRequirement) {
    this.listSpinning = true;
    this.requirementListInstance
      .requestData(params)
      .catch((err) => {
        this.$message.warning(err);
      })
      .finally(() => {
        this.listSpinning = false;
      });
  }
  private handleSearch() {
    this.removeRequirementForSearch();
    const params: ISearchParams = {};
    if (this.searchByKeyword !== '') {
      params.title = this.searchByKeyword;
    }
    if (this.searchByStatus !== 'All') {
      params.status = this.searchByStatus;
    }
    this.initRequirements(params);
  }
  private handleRefresh() {
    this.searchByKeyword = '';
    this.searchByStatus = 'All';
    this.initRequirements(this.requirementForSearch);
  }
  private addRequirement() {
    this.$router.push({ name: 'CreateRequirement' });
  }
  private removeRequirementForSearch() {
    this.requirementForSearch = {};
    this.searchTags.length = 0;
  }
  private removeSearchParams(key: keyof IGetRequirement) {
    delete this.requirementForSearch[key];
    this.searchTags = searchParamsConvertArray(this.requirementForSearch);
    this.handleRefresh();
  }
  private showSearchModal() {
    this.searchModalRef.showModal();
  }
  private handleModalSearch(params: IGetRequirement) {
    this.requirementForSearch = params;
    this.searchTags = searchParamsConvertArray(this.requirementForSearch);
    this.handleRefresh();
  }
  private getMoreData() {
    this.addLoading = true;
    this.requirementListInstance
      .requestMoreData()
      .catch((err) => 'getMoreRequirements err' + err)
      .finally(() => {
        this.addLoading = false;
      });
  }
  private handleItemClick(requirement: IRequirementInfo) {
    this.requirementListInstance.list.changeCurrent(requirement);
  }
  private refreshDetail(requirement: IRequirementInfo) {
    this.detailSpinning = true;
    this.requirementListInstance
      .requestDetail({id: requirement.id})
      .catch((err) => {
        if (err !== 'CANCEL') {
          this.$message.warning(err);
        }
      })
      .finally(() => {
        this.detailSpinning = false;
      });
  }
  private editRequirement(requirement: IRequirementInfo) {
    this.requirementListInstance.changeEditItem(requirement);
    this.$router.push({
      name: 'UpdateRequirement',
    });
  }
  private deleteRequirement(requirementId: string) {
    this.requirementListInstance
      .requestDeleteById(requirementId)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.warning(err);
      });
  }
  private changeStatus(params: {
    requirement: IRequirementInfo;
    status: IRequirement.IRequirementStatus;
  }) {
    this.requirementListInstance.requestUpdateStatus(
      params.requirement,
      params.status,
    );
  }
  private changeLabel(params: {
    requirement: IRequirementInfo;
    labels: ILabelInfo[];
  }) {
    this.requirementListInstance.updateLabel(params.requirement, params.labels);
  }
  private changeComment(params: {
    type: 'ADD' | 'CHANGE';
    requirement: IRequirementInfo;
    comment: ICreateOrUpdateComment;
  }) {
    const { type, requirement, comment } = params;
    this.requirementListInstance.updateComment(type, requirement, comment);
  }
}
